import { Button } from "antd";
import styled from "styled-components";

export const PasswordEditableButton = styled(Button)`
    color: ${props => props.theme.features.administration.modalForm.secondaryButton.color};
    background-color: ${props => props.theme.features.administration.modalForm.secondaryButton.bgColor};
    border-color: transparent;
    
    &:hover, &:active {
        color: ${props => props.theme.features.administration.modalForm.secondaryButton.hoverColor} !important;
        border-color: ${props => props.theme.features.administration.modalForm.secondaryButton.hoverBorderColor} !important;
    }
`;
